<template>
  <div>
    <div
      class="modal show fade modal text-left "
      style="display: block;"
      v-if="show"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body" v-if="typeof list != 'undefined' &&  Object.keys(list).length != 0">
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Transaction Amount</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark pr-1"
                  >{{ parseFloat(actualAmount / 100).toFixed(amountDecimalPlaces)}}</span
                  ><span class="badge-light-success badge ">{{list.from_currency}}</span>
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Transaction Currency</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{list.from_currency}}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Source</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{list.source}}</span
                  >
                </div>
                <div class="  border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Request</a
                      >
                    </h6>
                  </div>
                  <div class="card-body invoice-padding ">
                    <div class="row invoice-spacing">
                      <div class="col-xl-12 p-0">
                        <vue-json-pretty v-if="list.request" :path="'res'" :data="list.request" :showDoubleQuotes="false"> </vue-json-pretty>
                        <span v-else>N/A</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="  border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Response</a
                      >
                    </h6>
                  </div>
                  <div class="card-body invoice-padding ">
                    <div class="row invoice-spacing">
                      <div class="col-xl-12 p-0">
                        <vue-json-pretty v-if="list.response" :path="'res'" :data="list.response" :showDoubleQuotes="false"> </vue-json-pretty>
                        <span v-else>N/A</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >ExchangeRate Without MarkUp</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{list.exchange_rate}}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >MarkUp</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{list.markup+' %'}}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >ExchangeRate With MarkUp</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{calculateProcessedAndExchangeRateAmount(true)}}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Processed Currency</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                  >{{list.to_currency}}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-primary  font-weight-bolder"
                      >Processed Amount </a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark pr-1"
                  >{{calculateProcessedAndExchangeRateAmount()}}</span
                  ><span class="badge-light-success badge ">{{list.to_currency}}</span>
                </div>
                <div class="d-flex align-items-center pb-1 border-bottom mb-1">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                          href="javascript:void(0)"
                          class="text-primary  font-weight-bolder"
                      >Revenue </a
                      >
                    </h6>
                  </div>
                  <span
                      style="font-size: larger"
                      v-if="transactionType == 6"
                      class=" font-weight-bolder text-danger pr-1"
                  >- {{calculateRevenue()}}</span>
                  <span
                      style="font-size: larger"
                      v-else
                      class=" font-weight-bolder text-dark pr-1"
                  >{{calculateRevenue()}}</span>
                  <span class="badge-light-success badge ">{{list.to_currency}}</span>
                </div>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="$emit('hide')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
export default {
  components: {
    VueJsonPretty,
  },
  props: ["show", "exchangeData", "index"],
  data() {
    return {
      list: [],
      actualAmount: 0,
      transactionType: '',
      // showModal: false,
    };
  },
  methods:{
    calculateRevenue(){
      let amount = parseFloat(this.actualAmount)
      let markup = parseFloat(this.list.markup)
      let exchangeRate = parseFloat(this.list.exchange_rate)
      let tempWithoutMarkup = amount * exchangeRate
      exchangeRate = (parseFloat(exchangeRate) * (parseFloat(markup/100)))+ parseFloat(exchangeRate)
      let tempWithMarkup = amount * exchangeRate
      return parseFloat((tempWithMarkup - tempWithoutMarkup )/100).toFixed(this.amountDecimalPlaces) // revenue
    },
    calculateProcessedAndExchangeRateAmount(forExchangeRate= false){
      let amount = parseFloat(this.actualAmount)
      let markup = parseFloat(this.list.markup)
      let exchangeRate = parseFloat(this.list.exchange_rate)
      exchangeRate = (parseFloat(exchangeRate) * (parseFloat(markup/100)))+ parseFloat(exchangeRate)
      if(forExchangeRate){
        return exchangeRate
      }
      let processedAmount = amount * exchangeRate
      return parseFloat(processedAmount/100).toFixed(this.amountDecimalPlaces)
    },
  },
  watch: {
    show() {
      if(this.exchangeData.total_amount != this.exchangeData.amount){
        this.actualAmount = this.exchangeData.total_amount
      }else{
        this.actualAmount = this.exchangeData.amount
      }

      this.transactionType = this.exchangeData.transaction_type_id

      this.list = this.exchangeData.exchange_details;
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

